import { connect } from 'react-redux'

import { doMarkAsUnread, doMarkAsRead } from 'actions/tickets'
import { makeSelectTicketIsUnread } from 'selectors/tickets'

import View from './view'

const select = () => {
  const selectTicketIsUnread = makeSelectTicketIsUnread()
  return (state, props) => {
    return {
      isUnread: selectTicketIsUnread(state, props),
    }
  }
}

const perform = {
  markAsRead: doMarkAsRead,
  markAsUnread: doMarkAsUnread,
}

export default connect(select, perform)(View)
